import React from 'react'

function Footer() {
  return (
    <div className='absolute-center'>
      @clone
    </div>
  )
}

export default Footer;

